import { DateInput, IDateFormatProps } from "@blueprintjs/datetime";
import React, { useContext, useEffect, useState } from "react";
import { DB_REF } from "../../constants/DB";
import { firebaseContext } from "../../contexts/FirebaseContext";
import { Player } from "../../interfaces/Player.Interface";
import { dateToFirestore } from "../../services/DateToFirestore";
import img from "../../img/player_default.png";
import "./AddGoalsAndAssists.Styles.scss";
import Inputbox from "../../components/elements/Inputbox.Element";
import { Button } from "@blueprintjs/core";

export default function AddGoalsAndAssistsComponent() {
  const [date, setDate] = useState(new Date());
  const [currentSeason, setCurrentSeason] = useState(0);

  const [matches, setMatches] = useState(0);
  const [minutesPlayed, setMinutesPlayed] = useState(0);

  const [isPracticeDay, setIsPracticeDay] = useState(false);
  const firebase = useContext(firebaseContext);
  const [players, setPlayers] = useState<Player[]>([]);
  const [attendance, setAttendance] = useState<String[]>([]);
  const [stats, setStats] = useState<
    { goals: number; assists: number; saves: number }[]
  >([]);

  const jsDateFormatter: IDateFormatProps = {
    // note that the native implementation of Date functions differs between browsers
    formatDate: (date) => date.toLocaleDateString(),
    parseDate: (str) => new Date(str),
    placeholder: "M/D/YYYY",
  };

  const onChange = async (date: Date) => {
    setDate(date);
  };

  const getPlayers = async () => {
    try {
      const docs = await firebase
        .firestore()
        .collection(DB_REF.players)
        .where("active", "==", true)
        .get();
      setPlayers([]);

      docs.forEach((ele) => {
        setPlayers((old) => [...old, ele.data() as any]);
      });
    } catch (err) {
      console.log(err);
    }
  };

  const getSeason = async () => {
    const doc = await firebase
      .firestore()
      .collection(DB_REF.currentSeason)
      .doc("season")
      .get();

    if (doc.exists) {
      setCurrentSeason(doc.data()!.no);
    } else {
      setCurrentSeason(0);
    }
  };

  const checkPracticeDay = async () => {
    const docs = await firebase
      .firestore()
      .collection(DB_REF.practices)
      .where("date", "==", dateToFirestore(date))
      .get();

    if (!docs.empty) {
      setIsPracticeDay(true);
    } else {
      setIsPracticeDay(false);
    }
  };

  const onChangeStats = (index: number, key: string, val: string) => {
    let oldstats = [...stats];

    oldstats[index] = {
      ...oldstats[index],
      [key]: parseInt(val) || 0,
    };

    setStats(oldstats);
  };

  const renderPlayers = () => {
    let pl: Player[] = [];

    for (let i = 0; i < attendance.length; i++) {
      for (let j = 0; j < players.length; j++) {
        if (attendance[i] === players[j].playerId) {
          pl.push(players[j]);
        }
      }
    }

    return pl.map((ele, index) => {
      return (
        <div key={index} className="goals-player-card">
          <div className="info">
            <div>
              <img style={{ height: 100 }} src={ele.imageUrl || img} alt="" />
            </div>
            <div>
              {ele.firstName} {ele.lastName}
            </div>
            <div>{ele.position}</div>
            <div style={{ fontFamily: "tshirt" }}>{ele.jerseyNumber}</div>
          </div>
          <div className="inputs" style={{ padding: 40 }}>
            <Inputbox
              id="goals"
              onChange={(val) => onChangeStats(index, "goals", val)}
              label="No of Goals"
              helperText="No of goals scored ex: 1"
              value={
                stats[index].goals ? stats[index].goals.toString() || "0" : "0"
              }
              type="number"
            />
            <Inputbox
              id="assists"
              onChange={(val) => onChangeStats(index, "assists", val)}
              label="No of Assists"
              helperText="No of assists ex: 1"
              value={
                stats[index].assists
                  ? stats[index].assists.toString() || "0"
                  : "0"
              }
              type="number"
            />
            <Inputbox
              id="saves"
              onChange={(val) => onChangeStats(index, "saves", val)}
              label="No of Saves (for goalkeepers)"
              helperText="No of saves ex: 1"
              value={
                stats[index].saves ? stats[index].saves.toString() || "0" : "0"
              }
              type="number"
            />
          </div>
        </div>
      );
    });
  };

  const getPlayerData = async () => {
    const docs = await firebase
      .firestore()
      .collection(DB_REF.practiceData)
      .where("type", "==", "present")
      .where("date", "==", dateToFirestore(date))
      .get();

    if (!docs.empty) {
      setAttendance([]);
      setStats([]);

      docs.forEach(async (ele) => {
        const playerId = ele.data().playerId;
        const docs = await firebase
          .firestore()
          .collection(DB_REF.matchStats)
          .doc(dateToFirestore(date) + "." + playerId)
          .get();

        if (docs.exists) {
          setStats((old) => [...old, { ...(docs.data() as any) }]);
          setMinutesPlayed(docs.data()!.minutesPlayed);
          setMatches(docs.data()!.matches);
          setCurrentSeason(docs.data()!.currentSeason);
        } else {
          setStats((old) => [...old, { assists: 0, goals: 0, saves: 0 }]);
        }
        setAttendance((old) => [...old, playerId]);
      });
    } else {
      setAttendance([]);
      setStats([]);
    }
  };

  useEffect(() => {
    getSeason();
    checkPracticeDay();
    getPlayerData();
  }, [date]);

  useEffect(() => {
    getPlayers();
  }, []);

  const saveStats = () => {
    for (let i = 0; i < stats.length; i++) {
      const playerId = attendance[i];
      const stat = {
        playerId,
        ...stats[i],
        currentSeason,
        matches,
        minutesPlayed,
      };

      firebase
        .firestore()
        .collection(DB_REF.matchStats)
        .doc(dateToFirestore(date) + "." + playerId)
        .set(stat);
    }
  };

  const renderMatchesAndTimeInputs = () => {
    return (
      <div>
        <div style={{ display: "flex", justifyContent: "center" }}>
          <Inputbox
            onChange={(val) => setMatches(parseInt(val) || 0)}
            value={matches.toString() || "0"}
            id="matches"
            type="number"
            placeHolder="Matches"
            label="Matches Played"
          />
          <Inputbox
            onChange={(val) => setMinutesPlayed(parseInt(val) || 0)}
            value={minutesPlayed.toString() || "0"}
            id="minutes"
            type="number"
            placeHolder="Matches"
            label="Minutes Played"
          />
        </div>
        <div style={{ padding: 20, display: "flex", justifyContent: "center" }}>
          <Button intent="success" text="Save match data" onClick={saveStats} />
        </div>
      </div>
    );
  };

  const renderSection = () => {
    if (isPracticeDay) {
      return (
        <div>
          <div>{renderMatchesAndTimeInputs()}</div>
          <div>{renderPlayers()}</div>
        </div>
      );
    } else {
      return (
        <div
          style={{
            textAlign: "center",
            height: "80vh",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          Not a practice day, to add goals and assists create a practice day
          from attendance tab
        </div>
      );
    }
  };

  return (
    <div>
      <div
        style={{
          padding: 20,
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
        }}
      >
        <div style={{ padding: 10 }}>Add Goals And Assists</div>
        <div style={{ padding: 10 }}>
          <DateInput {...jsDateFormatter} value={date} onChange={onChange} />
        </div>
      </div>
      <div>{renderSection()}</div>
    </div>
  );
}
